
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormDescription, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { useFormContext } from 'react-hook-form';

export const ReasonField: React.FC = () => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name="reason"
      render={({ field }) => (
        <FormItem>
          <FormLabel>เหตุผลในการแก้ไข</FormLabel>
          <FormControl>
            <Textarea
              placeholder="ระบุเหตุผลในการแก้ไขข้อมูล"
              {...field}
            />
          </FormControl>
          <FormDescription>
            เหตุผลนี้จะถูกบันทึกไว้ในระบบเพื่อการตรวจสอบ
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
